import type { ComponentProps } from "react";
import { useRef } from "react";
import { css, styled } from "styled-components";

export function StickyGridItem({
  stickX,
  ...props
}: { stickY?: boolean; stickX?: boolean | string } & ComponentProps<
  typeof StyledStickyGridItem
>) {
  const ref = useRef<HTMLDivElement>(null);

  return <StyledStickyGridItem ref={ref} {...props} $stickX={stickX} />;
}

const StyledStickyGridItem = styled.div<{ $stickX?: boolean | string }>`
  ${({ $stickX }) => {
    if ($stickX === true) {
      return css`
        position: sticky;
        left: 0;
        right: 0;
      `;
    }

    if (typeof $stickX === "string") {
      return css`
        position: sticky;
        left: ${$stickX};
      `;
    }

    return undefined;
  }}
`;
